function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import { Container, HiddenCheckbox, StyledCheckbox, StyledContent, StyledLabel, ValidationText } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Checkbox = function Checkbox(props) {
  var checked = props.checked,
    dataTestId = props.dataTestId,
    disabled = props.disabled,
    name = props.name,
    label = props.label,
    onChange = props.onChange,
    undefinedMark = props.undefinedMark,
    negative = props.negative,
    textValidation = props.textValidation,
    type = props.type,
    ariaLabel = props.ariaLabel,
    readOnly = props.readOnly;
  var checkboxIcon = undefinedMark ? 'minus' : 'check';
  return ___EmotionJSX("div", null, ___EmotionJSX(Container, null, ___EmotionJSX(StyledContent, {
    htmlFor: name,
    disabled: disabled,
    readOnly: readOnly
  }, ___EmotionJSX(HiddenCheckbox, {
    "data-test-id": dataTestId + "-input-checkbox",
    checked: checked,
    disabled: disabled,
    id: name,
    name: name,
    onChange: onChange,
    type: type
  }), ___EmotionJSX(StyledCheckbox, _extends({}, props, {
    "data-test-id": dataTestId + "-checkbox",
    role: "checkbox",
    "aria-checked": checked,
    title: "checkbox"
  }), !!checked && ___EmotionJSX(Icon, {
    type: type === 'radio' ? 'bullet' : checkboxIcon
  })), ___EmotionJSX(StyledLabel, props, ___EmotionJSX(Text, {
    dataTestId: dataTestId + "-label",
    dimmed: true,
    size: "t3",
    ariaLabel: ariaLabel
  }, label)))), negative && textValidation && ___EmotionJSX(ValidationText, null, ___EmotionJSX(Text, {
    size: "t4",
    variant: "negative"
  }, textValidation)));
};
Checkbox.propTypes = {
  checked: PropTypes.bool,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]).isRequired,
  name: PropTypes.string.isRequired,
  negative: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  textValidation: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  undefinedMark: PropTypes.bool,
  ariaLabel: PropTypes.string
};
Checkbox.defaultProps = {
  type: 'checkbox'
};
export default Checkbox;